module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_tool1.e34d2.png";